export const SET_VALUE = (state, [key, value]) => {
  state[key] = value
}

// ------------
// FORM
// ------------
export const SET_FORM_VALUE = (state, [key, value]) => {
  state.form[key] = value
}

export const SET_FORM_PUSH_WAREHOUSE = (state, payload) => {
  state.form.warehouses.push({ ...payload })
}

export const SET_FORM_UPDATE_WAREHOUSE = (state, [index, value]) => {
  state.form.warehouses[index] = value
}

export const SET_FORM_OPTION_VALUE = (state, [key, value]) => {
  state.form[key].value = value
}

export const RESET_FORM = (state, payload) => {
  state.form = JSON.parse(JSON.stringify(state.formDefault))
}

export const REMOVE_WAREHOSE = (state, index) => {
  state.form.warehouses.splice(index, 1)
}

// ------------
// WAREHOUSE FORM
// ------------
export const SET_FORM_VALUE_WAREHOUSE = (state, [key, value]) => {
  state.warehouseForm[key] = value
}

export const RESET_FORM_WAREHOUSE = (state, payload) => {
  state.warehouseForm = JSON.parse(JSON.stringify(state.warehouseDefault))
}
